import Icon from "./IconBase.js";

const EyeIcon = (props) => {
  return (
    <Icon width="17" height="16" viewBox="0 0 17 16" {...props}>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5253_57572)">
          <path
            d="M1.16669 8.00002C1.16669 8.00002 3.83335 2.66669 8.50002 2.66669C13.1667 2.66669 15.8334 8.00002 15.8334 8.00002C15.8334 8.00002 13.1667 13.3334 8.50002 13.3334C3.83335 13.3334 1.16669 8.00002 1.16669 8.00002Z"
            stroke="#00B0F5"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.5 10C9.60457 10 10.5 9.10457 10.5 8C10.5 6.89543 9.60457 6 8.5 6C7.39543 6 6.5 6.89543 6.5 8C6.5 9.10457 7.39543 10 8.5 10Z"
            stroke="#00B0F5"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5253_57572">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};

export default EyeIcon;
